const ORIGIN_BY_PLACEMENT = {
  top: 'bottom center',
  bottom: 'top center',
  left: 'center right',
  right: 'center left'
};

/**
 * Adjusts a given element for the current zoom level.
 * @param {*} element
 * @returns
 */
const adjustForZoom = (element) => {
  const zoom = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--app-zoom')) || 1;

  if (!element || element.dataset.zoomFixed) {
    return;
  }

  const style = getComputedStyle(element);
  const placement = element.getAttribute('data-popper-placement') || '';
  const transform = style.transform;
  const composed = transform === 'none' ? `scale(${zoom})` : `${transform} scale(${zoom})`;

  element.style.transform = composed;
  element.style.transformOrigin = ORIGIN_BY_PLACEMENT[placement] || 'center center';
  element.dataset.zoomFixed = 'true';
};

/**
 * Adjusts dynamically added popovers and tooltips for zoom level.
 * This is a workaround for Bootstrap's popper.js not handling zoom correctly.
 */
export const adjustElementsForZoom = () => {
  const observer = new MutationObserver((mutations) => {
    for (const { addedNodes } of mutations) {
      for (const node of addedNodes) {
        if (!(node instanceof HTMLElement)) {
          continue;
        }

        if (
          node.classList.contains('popover') ||
          node.classList.contains('tooltip') ||
          node.classList.contains('dropdown-menu') ||
          node.classList.contains('driver-popover')
        ) {
          requestAnimationFrame(() => adjustForZoom(node));
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};
